<template>

  <div id="vitrine">
    <carousel class="carousel" :autoplay=true :perPage=1 :paginationEnabled=true :autoplayHoverPause=true :loop=true :autoplayTimeout=10000>

        <!-- <slide class="slide aniversario">

          <div class="container">
            <div class="row">
              <div class="content col-md-12">
                <h2 class="title">
                  A festa é sua. Todos ganham presente!
                </h2>
                <div class="description">
                  Organize uma festa ou evento, e o seus presentes podem se transformar em doações
                </div>
                <div class="button">
                  <router-link to="/aniversariodobem" href="">Crie o seu Convite</router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="image">
            <img class="img-responsive" :src="vitrineAniversario"/>
          </div>

        </slide> -->

        <slide class="slide">

          <div class="container">
            <div class="row">
              <div class="content col-md-12">
                <h2 class="title">
                  Empoderamos pessoas que fazem o bem,
                  para que elas façam ainda mais!
                </h2>
                <div class="description">
                  Sua Organização Social necessita de apoio para fomentar as arrecadações e melhorar a comunicação com seus doadores? A Click2Giv tem as ferramentas que você precisa!
                </div>
                <div class="button">
                  <router-link to="/create-project" href="">Cadastre sua ONG</router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="image">
            <img class="img-responsive" :src="vitrine1"/>
          </div>

        </slide>

        <slide class="slide">

          <div class="container">
            <div class="row">
              <div class="content col-md-12">
                <h2 class="title">
                  “Nós acreditamos no bem e nas pessoas que fazem o bem!”
                </h2>
                <div class="description">
                  Conectamos pessoas que querem de alguma maneira contribuir e ajudar, com Organizações Sociais que necessitam de contribuições.
                  Escolha uma entidade que toca o seu coração e participe como puder!
                </div>
                <div class="button">
                  <router-link to="/signup" href="">Cadastre-se</router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="image">
            <img :src="vitrine2"/>
          </div>

        </slide>

        <slide class="slide">

          <div class="container">
            <div class="row">
              <div class="content right col-md-12">
                <h2 class="title">
                  Descontos do Bem: uma rede que transforma vidas!
                </h2>
                <div class="description">
                  Você gosta de promoções e descontos? Está procurando uma oferta especial?
                  Aqui você encontra centenas de lojas, descontos especiais e ao comprar um produto você ajuda uma Organização Social cadastrada em nossa plataforma.
                </div>
                <div class="button">
                  <a href="/descontosdobem" target="_blank">Conheça</a>
                </div>
              </div>
            </div>
          </div>

          <div class="image">
            <img :src="vitrine3"/>
          </div>

        </slide>

    </carousel>
  </div>

</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import vitrineAniversario from '../../assets/images/bkg-top-aniversario.jpg';
import vitrine1 from '../../assets/images/vitrine1.jpg';
import vitrine2 from '../../assets/images/vitrine2.jpg';
import vitrine3 from '../../assets/images/vitrine3.jpg';

export default{
  components: {
    Carousel,
    Slide,
  },
  data() {
    return{
      vitrine1: vitrine1,
      vitrine2: vitrine2,
      vitrine3: vitrine3,
      vitrineAniversario: vitrineAniversario
    }
  }
}

</script>

<style scoped lang="scss">
#vitrine{
  width: 100%;
  height: 450px;
  background-color: #000;
  overflow: hidden;

  .carousel{
    width: 100%;

    .slide{
      width: 100%;
      height: 450px;
      position: relative;

      .row{
        position: relative;
      }

      .content{
        position: absolute;
        top: 80px;
        z-index: 10;
        width: 100%;
        @media screen and (min-width: 996px){
          top: 40px;
          width: 450px;
        }

        &.right{
          right: 0;
        }

        .title{
          font-size: 2em;
          font-family: RalewayBold;
          color: #fff;
          text-shadow: 1px 1px 3px #000;
          @media screen and (max-width: 996px){
            font-size: 1.2em;
          }

          span{
            text-shadow: 1px 1px 3px #000;
            font-size: 26px;
            color: #00AE39;
          }
        }

        .description{
          margin-top: 20px;
          font-family: RalewayRegular;
          color: #fff;
          text-shadow: 1px 1px 3px #000;
        }

        .button{
          margin-top: 20px;
          a{
            font-family: RalewayRegular;
            display: block;
            width: 220px;
            padding: 10px;
            font-size: 22px;
            color: #fff;
            background-color: #00AE39;
            text-align: center;
            border-radius: 40px;
            text-decoration: none;
          }
        }


      }

      .image{
        max-height: 450px;
        width: 100%;
        position: absolute;
        z-index: 9;
        overflow: hidden;

        img{
          height: 450px;
          opacity: 0.6;
          object-fit: cover;
          @media screen and(min-width: 996px){
            width: 100%;
            opacity: 1;
          }
        }

      }

      &.aniversario{
        .content{
          margin-top: 20px;
          .title{
            font-size: 40px;
          }
        }
        .image{
          img{
            opacity: 0.7;
            object-fit: cover;
          }
        }
      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/home/Vitrine.vue